export const getUniqueTruthyByKey = <
    T extends Record<string, unknown>,
    K extends keyof T,
>(
    items: T[],
    key: K,
): NonNullable<T[K]>[] => {
    return Array.from(
        new Set(items.map((item) => item[key]).filter(Boolean)),
    ) as NonNullable<T[K]>[];
};

export const getUniqueDefinedValues = <T>(
    items: readonly T[],
): NonNullable<T>[] => {
    return Array.from(
        new Set(items.filter((item): item is NonNullable<T> => item != null)),
    );
};
